<template>
  <router-link class="homework-list-item" tag="div" :to="'/homework/' + data.id">
    <div class="wrapper">
      <div class="flex">
        <div class="flex content-start">
          <div v-if="teacher" class="teacher">
            <div class="img" :style="$bgd(teacher.gravatar)" />
            <span>{{ teacher.name }}</span>
          </div>
          <i class="with anyteachicon anyteach-xunhuan" />
          <StudentName v-if="student" v-bind="student" hide-age />
        </div>
        <div v-if="data.status > 0" class="status" :class="'status-' + data.status">
          <i v-if="homeworkStatus[data.status].icon" :class="homeworkStatus[data.status].icon" />
          {{ homeworkStatus[data.status].title }}
        </div>
      </div>
      <div v-for="item in lessons" :key="item.lesson.id" class="flex">
        <span v-if="getLessonTitle(item).length" class="schedule">{{ getLessonTitle(item) }}</span>
      </div>
      <div class="flex">
        <span class="op">{{ time }}</span>
        <span class="op schedule-title" v-if="schedule">{{ schedule.title }}</span>
      </div>
    </div>
  </router-link>
</template>
<script>
import StudentName from "@/components/public/StudentName"
import { homeworkStatus } from "./utils"

export default {
  name: "HomeworkListItem",
  components: {
    StudentName
  },
  props: ["data", "teacher", "schedule"],
  computed: {
    user() {
      return this.$store.state.user
    },
    student() {
      if (!this.user || !this.user.student) return null
      return this.user.student.find(item => item.id === this.data.student_id)
    },
    lessons() {
      return this.data.lessonTitle
    },
    time() {
      if (!this.data) return null
      const time = this.$moment(this.data.schedule_time.start_time)
      const now = this.$moment()
      if (time.isBefore(now, "year")) {
        return time.format("YYYY年M月D日 dddd HH:mm")
      } else {
        return time.format("M月D日 dddd HH:mm")
      }
    },
  },
  data() {
    return {
      homeworkStatus
    }
  },
  methods: {
    getLessonTitle(data) {
      let str = ""
      if (data.series) str += `${data.series.title}`
      if (data.book) str += ` / ${data.book.title}`
      if (data.unit) str += ` / ${data.unit.title}`
      if (data.lesson) str += str.length ? ` / ${data.lesson.title}` : data.lesson.title
      return str
    }
  }
}
</script>
<style scoped lang="scss">
@import "./style.scss";

.homework-list-item {
  @include card();
  padding: 13px 5%;
  margin: 0 auto 15px auto;
  &:active {
    opacity: 0.6;
  }
  .op {
    opacity: 0.6;
  }

  .units {
    margin-left: 5px;
  }
  .with {
    margin: 0 7px;
    opacity: 0.6;
  }
  .flex {
    font-size: 0.85rem;
    width: 100%;
  }
  .content-start {
    justify-content: flex-start;
  }
  .schedule-title {
    white-space: nowrap;
  }
  h4 {
    font-size: 0.85rem;
    font-weight: 400;
  }

  .teacher {
    display: flex;
    align-items: center;
    .img {
      margin-right: 3px;
      $size: 16px;
      width: $size;
      height: $size;
      border-radius: 100%;
    }
  }
}
</style>
